<template>
  <!--下拉详情-->
  <div class="main">
    <section class="main-wrap">
      <el-row align="middle" class="main-item">
        <el-col :span="8" class="address">
          公司名称：<span>{{ details.companyName }}</span>
        </el-col>
        <el-col :span="8" class="address">
          联系人：<span>{{ details.relationName }}</span>
        </el-col>
        <el-col :span="8" class="address">
          联系电话：<span>{{ details.relationPhone }}</span>
        </el-col>
      </el-row>
      <el-row align="middle" class="main-item">
        <el-col :span="8" class="address">
          固定电话：<span>{{ details.fixTelphone }}</span>
        </el-col>
        <el-col :span="8" class="address">
          建立时间：<span>{{ details.createDate }}</span>
        </el-col>
      </el-row>
      <el-row align="middle" class="main-item">
        <el-col :span="24" class="address">
          是否业务客户：
          <span v-if="details.isBusiness==1" style="color: #BE2316">否</span>
          <span v-if="details.isBusiness==2" style="color: #BE2316">是</span>
        </el-col>
      </el-row>
      <el-row align="middle" class="main-item">
        <el-col :span="24" class="address item-remarks">
          备注：<span>{{ details.remarks }}</span>
        </el-col>
      </el-row>
      <div class="seeContacts">
        <p class="seeContacts-header">联系记录：</p>
        <div class="seeContacts-table">
          <el-row v-for="(item,index) in contactRecordData" :key="index" align="middle" class="seeContacts-con">
            <el-col :span="12">
              {{ item.createDate }}
            </el-col>
            <el-col :span="12">
              <span class="seeContacts-table-dc">{{ item.relationRecord }}</span>
            </el-col>
          </el-row>
        </div>
      </div>

    </section>
  </div>
</template>

<script type="text/ecmascript-6">
import * as get from '@/api/personal/customer/contacts/index.js' // 请求接口

export default {
  props: {
    details: {
      type: Object,
      default: () => {
        return {}
      }
    },
    relationId: {
      type: String,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      contactRecordData: []
    }
  },
  created() {
    get.getContactRecord({
      relationLogId: this.relationId
    }).then(res => {
      console.log(res)
      this.contactRecordData = res.result
    }).catch(error => {
      console.log(error)
    })
  }
}
</script>

<style scoped lang='scss'>
  @keyframes show {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
  .main-wrap{
    padding: 25px 20px 0px 20px;
    border-top: 1px solid #DBDDE1;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    transition: all 0.8s ease-in-out;
    animation: show 0.8s ease-in-out;

    .main-item{
      font-size: 14px;
      padding-bottom: 25px;
    }
    .seeContacts{
      .seeContacts-header{
        color: #BF2316;
        font-size: 15px;
        height: 40px;
        line-height: 40px;
      }
      .seeContacts-table{
        .seeContacts-con{
          font-size: 14px;
          height: 60px;
          line-height: 60px;
          border-bottom: 1px dashed #A6A6A6;
          &:last-child{
            border-bottom: none;
          }
        }
        .seeContacts-table-dc{
          color: #000;
          /*cursor: pointer;*/
        }
      }
    }

  }
</style>
